import { SyndigoServiceProvider } from "./provider.js";
import { formConfig, formSchema, serviceConfigSchema } from "./schemas.js";
export const provider = new SyndigoServiceProvider({
    name: 'syndigo',
    title: 'Syndigo',
    description: 'The Syndigo Commerce Experience Suite provides a comprehensive cloud-based PIM.',
    categories: ['ecommerce', 'pim'],
    links: [
        { title: 'Homepage', url: 'https://syndigo.com/' },
        { title: 'Docs', url: '/docs/services/providers/syndigo' }
    ],
    formSchema,
    formConfig,
    serviceConfigSchema
});
